import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Link from "@mui/material/Link";
import Layout from "../Layout";

export default function Confirmation() {
    return (
        <Layout>
            <Container maxWidth="sm" sx={{ py: { xs: 4, sm: 6 }, textAlign: "center" }}>
                <Typography variant="h1" sx={{ fontSize: "var(--h1)", mb: 3 }}>
                    Your new start paper work has been sent to HR, please keep
                    an eye on your email for your contract coming through.
                </Typography>
                <Typography variant="h2" sx={{ fontSize: "var(--h2)", mb: 2 }}>
                    If you need to contact HR you can do on:
                </Typography>
                <Stack spacing={1} alignItems="center">
                    <Link href="tel:01415301655" color="error" sx={{ fontSize: "1.5rem", minHeight: 44 }}>
                        0141 530 1655
                    </Link>
                    <Link
                        href="mailto:team@jedihrsolutions.co.uk"
                        color="error"
                        sx={{ fontSize: "1.5rem", minHeight: 44 }}
                    >
                        team@jedihrsolutions.co.uk
                    </Link>
                </Stack>
            </Container>
        </Layout>
    );
}
